// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__bihKV","label":"LabeledBox_label__1f6jL"};